import { ActividadEconomicaEmisor } from "../ActividadEconomicaEmisor";
import { ConfiguracionEmision } from "../ConfiguracionEmision";
import { CuentaSii } from "../CuentaSii";
import { DatosFacturacion } from "../PlanesUsuario/DatosFacturacion";
import { PlantillaImpresion } from "../PlantillaImpresion/PlantillaImpresion";
import { Sucursal } from "../Sucursal";
import { Emisor } from "./Emisor";
import { LogoWizardRequest } from "./LogoWizardRequest";

export class EmisorWizardRequest {
	usuarioId: string;
	emisorBase: Emisor;
	sucursal: Sucursal;
	actividades: ActividadEconomicaEmisor[];
	certificado: CertificadoRequest;
	logoEmisor: LogoWizardRequest;
	firstTime: boolean;
	fromPartner: boolean;
	facturacion: DatosFacturacion;

	compraCertificado?: CertificadoCompraWizard; 
	//configuraciones:ConfiguracionEmision[];
}

export interface FileRequest {
	sucursalId: string;
	emisorId: string;
	fileB64: string;
}

export class FolioRequest implements FileRequest {
	sucursalId: string;
	emisorId: string;
	timbrajeString: string;
	fileB64: string;
	consumeFolio: boolean;
	consumoFolio: ConsumoFolio;
}
export class ConsumoFolio {
	desde: number;
	hasta: number;
}
export class CertificadoRequest implements FileRequest {
	fileB64: string;
	sucursalId: string;
	emisorId: string;
	certificadoString: string;
	Rut: string;
	NombreEmpresa: string;
	Correo: string;
	fechaExp:Date;
    subtotal?: number = 0;
    iva?: number;
    neto?: number;
    total?: number;
}

export class PlantillaFileRequest {
	public tipoPlantillaString: string;
	fileB64: string;
}

export interface CertificadoCompraWizard {
	comprar: boolean;     
	duracion: 1 | 2 | 3;     
	garantia: boolean;     
	preciobase: number;       
	precioGarantia: number; 
	total: number;  
	certificadoGenerado: boolean; 
  }
